import React, {Fragment} from 'react';

import HeaderUno from '../../../Compartidos/HeaderUno';
import HeaderMetodos from '../../../../AuxiliaresPaginas/HeaderMetodos';

import { HrMetodos } from '../../../../Css/StyledHeader';
import { Flex, FlexFull, Links1Al10, ImgB10, ContainerEj,PEj } from '../../../../Css/StyledMatematica';

const Ejercitacion = () => {

    return (
        <Fragment>
            <HeaderUno />
            <HrMetodos margin='0 0.2rem 0.5rem 0.2rem' />
            <HeaderMetodos l1={"metodos/"} l2={"matematica/"} l3={"calculo/"} l4={"division/"} n1={"Métodos"} n2={"MATEMATICA"} n3={"CALCULO"} n4={"DIVISION"} componente={"EJERCITACION"} paciente={true} bgcolor="#23AAAF" color="white" width='96vw' shadow="0px 4px 4px rgba(0, 0, 0, 0.25)" display="none"/>

            <Flex height='65vh'>
                <FlexFull align='center' justify='center' wrap='wrap' width='100%' wm='100%' wt='100%' wd='90%' wlg='90%'>
                    
                    <Flex margin='3px 0px 3px 0px' direction='column'>
                        <Links1Al10 to={`/escritorio/metodos/matematica/calculo/division/ejercitacion/M121`}><ImgB10 src={`/img/portadas/M121.jpg`}  w='26vw' wm='24vw' wt='19vw' wd='16vw' wlg='14vw' border='solid 2px #23AAAF' bradius='10px' m='1vh 2.5vw 1vh 2.5vw' /></Links1Al10>
                        <PEj m='-4px'>1</PEj>
                    </Flex>
                </FlexFull>
            </Flex>
        </Fragment>    
    );
}
 
export default Ejercitacion;